module.exports = __webpack_public_path__ + "img/02030217.0608b28b.svg";